import api from "@services/api-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    data: []
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    RESET_ESPECIE_BENEFICIO: state => {
      state.especieBeneficio.loading = false;
    },

    SET_ESPECIE_BENEFICIO_LOADING: (state, loading) => {
      state.especieBeneficio.loading = loading;
    },

    SET_ESPECIE_BENEFICIO: (state, { data, links, meta }) => {
      state.especieBeneficio.data = data;
      state.especieBeneficio.links = links;
      state.especieBeneficio.meta = meta;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    isEspecieBeneficioLoading: state => () => {
      return state.especieBeneficio.loading;
    },

    getEspecieBeneficio: state => () => {
      return state.especieBeneficio.data;
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_ESPECIE_BENEFICIO({ commit, state }) {
      // Se ja esta buscando
      if (state.especieBeneficio.loading) return;

      commit("SET_ESPECIE_BENEFICIO_LOADING", true);

      api()
        .get(`especies-beneficios`)
        .then(response => {
          if (response.data.status) {
            commit("SET_ESPECIE_BENEFICIO", response.data);
          }
        })
        // .catch(error => {})
        .finally(() => commit("SET_ESPECIE_BENEFICIO_LOADING", false));
    },

    RESET_ESPECIE_BENEFICIO({ commit }) {
      commit("RESET_ESPECIE_BENEFICIO");
    }
  }
};

export default store;
